import PaymentHelper from "@/utils/payment-helper"
import {isAnyValuePresent} from "@/utils/helper-functions"

export default class Adyen {

    static get(pm, paymentData, store) {
        switch(pm.type) {
            case 'direct_debit':
                return Adyen.directDebit(pm, paymentData, store);
            case 'paypal_express_checkout':
                return Adyen.paypalExpressCheckout(store);
             case 'klarna_pay_now':
                return Adyen.klarnaPayNowCheckout(paymentData, store); 
        }
    }

    static directDebit(pm, paymentData, store) {
        const scheme = pm.configuration.scheme;
        switch (scheme) {
            case 'SEPA':
                return Adyen.sepa(paymentData, store);
            case 'BACS':
                return Adyen.bacs(paymentData);
            case 'ACH':
                return Adyen.ach(paymentData, store);
        }
    }

    static sepa(paymentData, store) {
        const { first_name, last_name, email, iban,company} = paymentData
        return {
            customer: {
                firstName: first_name,
                lastName: last_name,
                company: company,
                email: email,
                billingAddress: PaymentHelper.getCustomerBillingAddress(store)
            },
            bankAccount : {
                iban: iban,
            }
        }
    }

    static bacs(paymentData) {
        const { first_name, last_name, routing_number, account_number } = paymentData
        return {
            customer: {
                firstName: first_name,
                lastName: last_name,
            },
            bankAccount : {
                accountNumber: account_number,
                routingNumber: routing_number,
            }
        }
    }

  static ach(paymentData, store) {
        const { first_name, last_name, routing_number, account_number, account_type } = paymentData
        return {
            customer : {
                firstName: first_name,
                lastName: last_name,
                billingAddress: PaymentHelper.getCustomerBillingAddress(store)
            },
            bankAccount : {
                routingNumber: routing_number,
                accountNumber: account_number,
                accountType: account_type
            }
        }
  }

    static paypalExpressCheckout(store) {
        const { first_name, last_name, email, phone } = store.state.customer.data
        return {
            customer: {
                firstName: first_name,
                lastName: last_name,
                email: email,
                phone: phone,
                billingAddress: PaymentHelper.getCustomerBillingAddress(store)
            }
        }
    }



    static klarnaPayNowCheckout(paymentInfo, store) {
      const estimate = store.getters.estimate?.line_items;
      if (paymentInfo) {
        switch (paymentInfo.gateway_name) {
          case 'ADYEN':
            const lineItems = estimate?.map(lineItem => ({
              amount: lineItem.amount,
              description: lineItem.description,
              unitAmount:lineItem.unitAmount,
              taxAmount:lineItem.taxAmount,
              id: lineItem.id,
              quantity:lineItem.quantity
          }));
          const formData = store.getters.values("klarna_pay_now");
          let billingAddress =  PaymentHelper.getCustomerBillingAddress(store);

          let temp = {
            userEmail: formData.owner_email,
            country: formData.owner_country,
            lineItems: lineItems || []
          };

          if(isAnyValuePresent(billingAddress)){
            temp.cardBillingAddress = billingAddress;
          }

          return temp;
        }
      }
    }

}
